/* eslint-disable */
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$#!%*?&!#\$%&()*+,-.:;<=>?@[\\\]^_`{|}~/])(?![\\'"\s])^[^\\'"\s]{8,20}$/;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const dayRegex = /^(0[1-9]|[1@2]\d|3[01])$/;
export const monthRegex = /^(0[1-9]|1[012])$/;
export const yearRegex = /^\d{4}$/;
export const ssnRegex = /^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/;
export const notOnlyNumberRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9\s.,/#&-]+$/;
export const cityRegex = /^[A-Za-z\s]*$/;
// export const zipCodeRegex = /^[A-Za-z0-9]*[0-9][A-Za-z0-9]*$/;
// export const zipCodeRegex = /^[A-Za-z0-9]*[0-9]{3,5}(?:[\s-][0-9][A-Za-z0-9]{3,4})?$/;
export const zipCodeRegex = /^\d{5}(-\d{4}|[^0-9])?$/;
export const phoneRegex = /^(1\s?)?(\d{3}|\(\d{3}\))[\s\-]?\d{3}[\s\-]?\d{4}$/;
export const onlyAlphabetRegex = /^[A-Za-z]+(?:['’-][A-Za-z]+| [A-Za-z]+)*$/;
export const ResidentialAddressRegex = /^[0-9a-zA-Z\s.,#-]+$/gi;
export const refferedByRegex = '^[a-zA-Z0-9_]*$';
export const whiteSpaceRegex = /\s/;
// export const alphabetSpaceRegex = /^[a-zA-Z\s]*$/;
export const alphabetSpaceRegex = /^[A-Za-z]+(?:['’-][A-Za-z]+| [A-Za-z]+)*$/;
export const addressPOBoxRegex =
  /^(?!.*\b(p\.?\s*o\.?|po\s|po\s+box|p\.?\s*o\.?\s*box|post\s*office\s*box|post\s*box|mailbox|cpo\s*box|postal\s*box|box\s+|po_box|pobox|po\s*\d+|box\d+|pob)\b).*$/i;
export const einRegex = /^\d{2}-?\d{7}$/;

export const preventNonDigitKeyPress = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

  export const isMobileDeviceDetectRegex =
  /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    navigator.userAgent || navigator.vendor || window.opera
  );
